import { Container, Stack, Typography, Select, MenuItem, FormControl, Grid, InputLabel, Button, Autocomplete, DialogActions, DialogContent, Box, FormControlLabel, RadioGroup, FormLabel, Radio, Breadcrumbs, Link, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import { InputAdornment, TextField } from '@mui/material';
import Page from "../../components/Page";
import Controls from "../../components/controls/Controls";
import { addAlert, getReportLink, updateAlert} from "../../config/services/alert";
import { getReportsList} from "../../config/services/reports";
import _ from "lodash";
import DatePicker from "react-datepicker";
import { ReactComponent as CalendarIcon } from "../../assets/icons/Work time-amico.svg"
import { ReactComponent as WorkTimeIcon } from "../../assets/icons/Work time-amico.svg";
import { makeStyles } from '@mui/styles'
import { useLocation, useNavigate, useParams, Link as RouterLink } from "react-router-dom";
import { toast } from "react-hot-toast";
import ClearIcon from '@mui/icons-material/Clear';
import { ReactComponent as RightAngle } from '../../assets/icons/icon-angle-right.svg';

const useStyles = makeStyles({
  
  datePickerRow: {
    display: 'flex',
    alignItems: 'center',
    margin: '15px 0px 0px 50px',
  },
  removeText: {
    cursor: 'pointer',
    marginLeft: '10px',
    color: 'blue',
    textDecoration: 'underline',
}
});


export default function AddAlertForm() {
  
    const [frequency, setFrequency] = useState("")
    // const [uuid, setUuid] = useState("")
    // const [role, setRole] = useState("")
    // const [template, setTemplate] = useState("")
    const [status, setStatus] = useState(false)
    const [isPersonalInfo, setIsPersonalInfo] = useState('')
    const [personalInfoKeys, setPersonalInfoKeys] = useState([])
    const [mail, setMail] = useState([])
    const [reportName, setReportName] = useState("")
    const [reportsList, setReportsList] = useState([''])
    const [selectedReport, setSelectedReport] = useState([])
    const [recurrancePopup, setRecurrancePopup] = useState(false)
    const [startDateSelected, setStartDateSelected] = useState(null)
    const [endDateSelected, setEndDateSelected] = useState(null)
    const { id } = useParams();
    const location = useLocation();
    const item = location.state?.report;
    const navigate = useNavigate()
    const classes = useStyles()


    const validation = (obj) => {
        toast.dismiss()
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isMailsCorrect = obj.mail.every(email => emailRegex.test(email));
  
        if(!obj.reportsId.length>0 || !obj.reportsName.length>0){
          toast.error("Please select a report!")
          return false
        }
        if (obj.frequency !== 'Does Not Repeat'){
          if(obj.frequency === ''){
            toast.error('Please select frequency')
            return false
          }
          if(obj.startDate === null) {
            toast.error('Please enter start date')
            return false
          }
          if(obj.endDate === null) {
            toast.error('Please enter end date')
            return false
          }
        }
        if (obj.isPersonalInfo === ''){
          toast.error("Personal Information Present is mandatory")
          return false
        }
        if((obj.isPersonalInfo === true || obj.isPersonalInfo === 'true') && obj.personalInfoKeys.length === 0){
          toast.error("Please enter personal information keys!")
          return false
        }
        if(obj.mail.length>0 && isMailsCorrect===false) {
          toast.error('Please enter correct receipient mail Ids')
          return false
        }
        if(!obj.mail.length>0) {
          toast.error('Please enter receipient mail Ids')
          return false
        }

      return true; 
    }

    const handleSubmit = async() => {

        const reportsName = selectedReport?.filter(report => report !== '').map(report => report?.label);
        const reportsId = selectedReport?.filter(report => report !== '').map((report) => report?.value)
        const filteredEmails = mail.filter(email => email.trim() !== '');

        let obj = {
            reportsId: reportsId,
            reportsName: reportsName,
            frequency: frequency,
            // role: role,
            // template: template,
            // uuid: uuid,
            mail: filteredEmails,
            status: status,
            isPersonalInfo: isPersonalInfo,
            personalInfoKeys: [],
            lastRun: (id? item?.lastRun : null),
            lastRunSeconary:(id? item?.lastRunSecondary : null),
            startDate: startDateSelected?.toISOString(),
            endDate: endDateSelected?.toISOString(),
        }
        if(isPersonalInfo===true|| isPersonalInfo==='true'){
          obj.personalInfoKeys=personalInfoKeys
        }
        let isValid = validation(obj)
        if(!isValid){
          return
        }
        
        try {
            let response
            if(id) {
              obj._id = item?._id
              response = await updateAlert(obj)
            } else {
              response = await addAlert(obj);
            }
            if (response.status === 1){
              toast.success("Success!!")
              navigate(`/alertList`)
            }else{
              toast.error('**Error**')
            }
          } catch (error) {
            console.log('Error while submitting Alert: ' , error);
          }
        
    }

    useEffect(() => {
      if(item){
        const allReportsId = item?.reportsId
        const allReportsName = item?.reportsName
        const selectedOptions = allReportsId?.map((value, index) => ({
          value: value,
          label: allReportsName[index]?.reportName ? allReportsName[index]?.reportName : allReportsName[index]
        }));
        setFrequency(item?.frequency)
        setMail(item?.mail)
        setStatus(item?.status.toString())
        // setTemplate(item?.template)
        // setUuid(item?.uuid)
        // setRole(item?.role)
        if(item?.startDate && item?.endDate){
          const utcStartDate = new Date(item?.startDate)
          const utcEndDate = new Date(item?.endDate)
          const istStartDate = new Date(utcStartDate?.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
          const istEndDate = new Date(utcEndDate?.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
          setStartDateSelected(istStartDate)
          setEndDateSelected(istEndDate)
        }
        setSelectedReport(selectedOptions)
        setIsPersonalInfo(item?.isPersonalInfo.toString())
        setPersonalInfoKeys(item?.personalInfoKeys??[])
      }

    }, [item])
    
    const handleSearchReport = _.debounce((e, val) => {
      if(val)
      setReportName(val)
    }, 400)

    useEffect(() => { 
      fetchReports() 
    }, [reportName]);


    const fetchReports = () => {
      getReportsList({ pageNo: 0, search: reportName })
        .then(res => {
          let List = (res?.result || []).map((report) => {
              const { reportName: label, _id: value } = report;
              return { label, value };
            });
          if(selectedReport.length>0){
            List = List.filter(report => selectedReport.every(obj => obj.value !== report.value))
          }
          setReportsList(List)
        })
    }

    const handleMail = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        const updateMail = [...mail, ""];
        setMail(updateMail);
      }

    }
    const handlePersonalInfoKeys = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        const updatePIKeys = [...personalInfoKeys, ""];
        setPersonalInfoKeys(updatePIKeys);
      }

    }

  return (
      <Page title={`Extramarks | ${item ? 'Update' : 'Add'}Alert`}>
        <Stack spacing={2} pl={3}>
            <Breadcrumbs separator={<RightAngle />} aria-label="breadcrumb" className="breadcrumb">                    
                <Link underline="hover" key="1" color="inherit" component={RouterLink} to="/alertList" className="breadcrumbs_item_link">Alert List</Link>
                <Link aria-current="page" color="inherit" className="breadcrumbs_item_current">{item? 'Update' : 'Add'} Alert</Link>
            </Breadcrumbs>
        </Stack>
        <Container className='table_max_width'>

          <Grid container display={"flex"} justifyContent={'flex-start'} alignItems={'start'}>
            <Grid item md={6} sm={12} xs={12}>
              {/* <Stack direction="column" alignContent="center" justifyContent="space-between" mt={5} > */}
              <Grid item md={12}>
                <Typography variant="h4">{item? 'Update' : 'Add'} Alert</Typography>
                <Typography variant="body2">Share your report in a downloadable CSV format via email</Typography>
              </Grid>
              <Grid item md={10} sm={12} mt={4}>
                <FormControl fullWidth>
                    <Autocomplete
                        fullWidth
                        disablePortal
                        multiple
                        options={reportsList}
                        getOptionLabel={(option) => option?.label || ''}
                        // style={{ width: '50%' }}
                        value={selectedReport || ['']}
                        onChange={(event, newValue) => {setSelectedReport(newValue); setReportName('')}}
                        onInputChange={handleSearchReport}
                        renderInput={(params) => (
                        <TextField {...params} label="Report Name *" variant="outlined" />
                        )}
                    />
                </FormControl>
              </Grid>

              <Grid item md={10} sm={12} mt={2}>
                <FormControl fullWidth>
                  <InputLabel htmlFor="refresh_key">Frequency *</InputLabel>
                  <Select htmlFor="refresh_key" label="Frequency *" value={frequency ? frequency : ""} fullWidth onChange={(e) => {
                      setFrequency(e?.target?.value); 
                      setRecurrancePopup(true);
                      setStartDateSelected(null)
                      setEndDateSelected(null)
                    }}>
                    <MenuItem value="Does Not Repeat">Does Not Repeat</MenuItem>
                    <MenuItem value="Daily">Daily</MenuItem>
                    <MenuItem value="Weekly">Weekly</MenuItem>
                    <MenuItem value="Monthly">Monthly</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {frequency && frequency!=='Does Not Repeat' && <Grid container md={8}>
                      <Grid item md={12}>
                        <FormControl className="form-control">
                          <div className={classes.datePickerRow}>
                            <Typography className="report-form-label" variant="subtitle2" style={{margin: '0px 13px 0px 0px'}}>Start *</Typography>
                            <DatePicker
                                autoComplete='off'
                                dateFormat="dd/MM/yyyy" className="report_form_ui_input_date er-input-filter"
                                selected={startDateSelected}
                                minDate={new Date()}
                                // showTimeSelect
                                onChange={(date) => {
                                  if (date) {
                                      date.setHours(5);
                                      date.setMinutes(30);
                                  }
                                  setStartDateSelected(date);
                                }}
                                showYearDropdown={true}
                                showMonthDropdown={true}
                                dropdownMode="select"
                                placeholderText='Select..'
                                customInput={
                                    <TextField 
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="start">
                                                    <CalendarIcon />
                                                </InputAdornment>
                                            ),
                                        }} />
                                }
                            />
                          </div>
                        </FormControl>
                      </Grid>
                      <Grid item md={12}>
                        <FormControl>
                          <div className={classes.datePickerRow}>
                              <Typography className="report-form-label" variant="subtitle2" style={{margin: '0px 20px 0px 0px'}}>End *</Typography>
                                  <DatePicker
                                      autoComplete='off'
                                      dateFormat="dd/MM/yyyy" className="report_form_ui_input_date er-input-filter"
                                      selected={endDateSelected}
                                      minDate={startDateSelected ?? new Date()}
                                      onChange={(date) => {
                                        if (date) {
                                          date.setHours(5);
                                          date.setMinutes(30);
                                        }
                                        setEndDateSelected(date)}}
                                      showYearDropdown={true}
                                      showMonthDropdown={true}
                                      dropdownMode="select"
                                      placeholderText='Select..'
                                      customInput={
                                          <TextField
                                              InputProps={{
                                                  endAdornment: (
                                                      <InputAdornment position="start">
                                                          <CalendarIcon />
                                                      </InputAdornment>
                                                  ),
                                              }} />
                                      }
                                  />
                                  {endDateSelected && <span className={classes.removeText} onClick={e=>setEndDateSelected(null)}><ClearIcon style={{color:"#f45e29"}}/></span>}
                          </div>
                        </FormControl>
                      </Grid>
              </Grid>}

              {/* <Grid item md={10} sm={12} mt={2}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="personal information">Personal Infomation Present *</InputLabel>
                    <Select fullWidth id="personal information" label="Personal Infomation Present *" value={isPersonalInfo?isPersonalInfo:''} onChange={(e) => {setIsPersonalInfo(e.target.value); setPersonalInfoKeys([])}} >
                      <MenuItem value={'true'}>Yes</MenuItem>
                      <MenuItem value={'false'}>No</MenuItem>
                    </Select>
                  </FormControl>
              </Grid> */}

              <Grid item md={10} sm={12} mt={2}>
                <FormControl fullWidth>
                <Grid container>
                  <Grid item md={6} sm={12}>
                    <Typography variant="subtitle1" color={'grey'} fontWeight={400} marginTop={1}>Personal Information Present *</Typography>
                  </Grid>
                  <Grid item md={6} sm={12}>
                    <RadioGroup
                      value={isPersonalInfo?isPersonalInfo:''}
                      onChange={(e) => {setIsPersonalInfo(e.target.value); setPersonalInfoKeys([])}}
                      row
                      sx={{ml:1}}
                    >
                      <FormControlLabel value='true' control={<Radio />} label="Yes" />
                      <FormControlLabel value='false' control={<Radio />} label="No" />
                    </RadioGroup>
                  </Grid>
                </Grid>
                </FormControl>
              </Grid>

                {(isPersonalInfo===true||isPersonalInfo==='true')&& <Grid item md={10} sm={12} mt={2}>
                  <FormControl fullWidth>
                      <TextField fullWidth label="Personal Information Keys *"  value={personalInfoKeys?.join("\n")} onChange={e => setPersonalInfoKeys(e?.target?.value?.split("\n"))} onKeyDown={handlePersonalInfoKeys} type="text" multiline rows={2} ></TextField>
                  </FormControl>
                </Grid>}

                <Grid item md={10} sm={12} mt={2}>
                  <FormControl fullWidth>
                      <TextField fullWidth label="Enter recipient Mail Ids *"  value={mail?.join("\n")} onChange={e => setMail(e?.target?.value?.split("\n"))} onKeyDown={handleMail} type="text" multiline rows={4} ></TextField>
                  </FormControl>
                </Grid>

                <Grid item md={10} sm={12} mt={2}>
                  <FormControl fullWidth>
                    <InputLabel htmlFor="refresh_key">Status *</InputLabel>
                    <Select fullWidth id="refresh_key" label="Status *" value={status ? status : ""} onChange={(e) => setStatus(e.target.value)} >
                      <MenuItem value="true">Enable</MenuItem>
                      <MenuItem value="false">Disable</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>


              {/* </Stack> */}

              <Grid item xs={10} sm={12} mt={2}>
                <div>
                  <Controls.Button
                    onClick={handleSubmit}
                    type="submit"
                    text="submit"
                  />
                </div>
              </Grid>

            </Grid>

            <Grid item md={6} sm={12} xm={12}>
              <WorkTimeIcon />
            </Grid>

          </Grid>

        </Container>
      </Page>
  )
}



